// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.qrcode {
  justify-content: center;
}

.qrUrl, .totpCode {
  width: 100%;
  padding: 20px;
  text-align: center;
  margin-bottom: 10px; /* Optional spacing between divs */
  word-break: break-all;
}`, "",{"version":3,"sources":["webpack://./src/app/verification_2fa/verification_2fa.component.scss"],"names":[],"mappings":"AAAA;EAEI,uBAAA;AAAJ;;AAEA;EACE,WAAA;EACA,aAAA;EACA,kBAAA;EACA,mBAAA,EAAA,kCAAA;EACA,qBAAA;AACF","sourcesContent":[".qrcode {\n    //display: flex;\n    justify-content: center;\n}\n.qrUrl, .totpCode {\n  width: 100%;\n  padding: 20px;\n  text-align: center;\n  margin-bottom: 10px; /* Optional spacing between divs */\n  word-break: break-all;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
